import { Chip } from '@mui/material'
import { COLORS } from '../../../styles/variables'

export type NotificationTypeChipVariant =
  | 'join_request'
  | 'invitation'
  | 'team_invitation'
  | 'join_decided'
  | 'invitation_decided'
  | 'team_invitation_decided'
  | 'invitation_cancelled'
  | 'team_invitation_cancelled'
  | 'team_removed'

const CHIP_CONFIG: Record<
  NotificationTypeChipVariant,
  { label: string; sx: { bgcolor: string; color: string; borderColor: string } }
> = {
  join_request: {
    label: 'Заявка',
    sx: {
      bgcolor: 'rgba(34, 139, 230, 0.12)',
      color: COLORS.CERULEAN,
      borderColor: COLORS.CERULEAN,
    },
  },
  invitation: {
    label: 'Приглашение',
    sx: {
      bgcolor: 'rgba(76, 175, 80, 0.12)',
      color: COLORS.STOPLIGHT_GO_GREEN,
      borderColor: COLORS.STOPLIGHT_GO_GREEN,
    },
  },
  team_invitation: {
    label: 'Команда',
    sx: {
      bgcolor: 'rgba(34, 139, 230, 0.12)',
      color: COLORS.CERULEAN,
      borderColor: COLORS.CERULEAN,
    },
  },
  join_decided: {
    label: 'Заявка',
    sx: {
      bgcolor: 'rgba(34, 139, 230, 0.08)',
      color: COLORS.CERULEAN,
      borderColor: COLORS.CERULEAN,
    },
  },
  invitation_decided: {
    label: 'Приглашение',
    sx: {
      bgcolor: 'rgba(76, 175, 80, 0.08)',
      color: COLORS.STOPLIGHT_GO_GREEN,
      borderColor: COLORS.STOPLIGHT_GO_GREEN,
    },
  },
  team_invitation_decided: {
    label: 'Команда',
    sx: {
      bgcolor: 'rgba(34, 139, 230, 0.08)',
      color: COLORS.CERULEAN,
      borderColor: COLORS.CERULEAN,
    },
  },
  invitation_cancelled: {
    label: 'Приглашение',
    sx: {
      bgcolor: 'rgba(76, 175, 80, 0.08)',
      color: COLORS.STOPLIGHT_GO_GREEN,
      borderColor: COLORS.STOPLIGHT_GO_GREEN,
    },
  },
  team_invitation_cancelled: {
    label: 'Команда',
    sx: {
      bgcolor: 'rgba(34, 139, 230, 0.08)',
      color: COLORS.CERULEAN,
      borderColor: COLORS.CERULEAN,
    },
  },
  team_removed: {
    label: 'Команда',
    sx: {
      bgcolor: 'rgba(34, 139, 230, 0.08)',
      color: COLORS.CERULEAN,
      borderColor: COLORS.CERULEAN,
    },
  },
}

type Props = {
  variant: NotificationTypeChipVariant
}

export function NotificationTypeChip({ variant }: Props) {
  const config = CHIP_CONFIG[variant]

  return (
    <Chip
      size="small"
      label={config.label}
      variant="outlined"
      sx={{
        height: 22,
        fontSize: 11,
        fontWeight: 600,
        flexShrink: 0,
        ...config.sx,
      }}
    />
  )
}
